import { Observable } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, ActivatedRouteSnapshot } from '@angular/router';
import { ProcessParticipationApprovalRequirementType } from '../../models/process-models';
import { ReportingService } from '../../services/reporting.service';



@Component({
    selector: 'app-my-team',
    templateUrl: './my-team.component.html',
    styleUrls: ['./my-team.component.scss']
})
export class MyTeamComponent implements OnInit {
    isMyTeamSurveyTab: boolean;
    isReportOpened = false;
    isFeedbackTab = false;
    employeeId: number;
    teammatePersonId: number;
    requirementType: any = ProcessParticipationApprovalRequirementType;
    isPdfDownloadingInProgress = false;
    isDetailedReportClicked = false;

    private decimalScale = 10;
    constructor(private readonly route: ActivatedRoute, 
        private readonly router: Router,
        private reportingService: ReportingService) { }

    ngOnInit() {
        this.isReportOpened = this.route.snapshot.children.some(x => x.url.some(p => p.path === 'report'));
        this.getEmployeeIdOnRouterChanged(this.route)
            .subscribe(x => {
                this.employeeId = NaN;
                if (x && x['params']) {
                    this.isReportOpened = x.url.some(p => p.path === 'report');
                    this.employeeId = parseInt(x['params']['teammateEmployeeId'], this.decimalScale);
                    this.teammatePersonId = parseInt(x['params']['teammatePersonId'], this.decimalScale);
                }
            });
            this.employeeId = this.route.snapshot.firstChild.params['teammateEmployeeId'];
            this.teammatePersonId = this.route.snapshot.firstChild.params['teammatePersonId'];
            this.reportingService.individualReportDownloaded$
            .subscribe(x => this.isPdfDownloadingInProgress = !x);
            this.reportingService.summaryReportDownloaded$
            .subscribe(x => this.isPdfDownloadingInProgress = !x);
    }

    getButtonTitle() {
        return this.isDetailedReportClicked ? 'lang.reporting.showIndividualReport' : 
        'lang.reporting.showDetailedReport';
      }
    
      navigateToIndividualReport() {
        this.isDetailedReportClicked = !this.isDetailedReportClicked;
        this.reportingService.swipeReport(this.isDetailedReportClicked);
      }

      downloadIndividualPdf() {
        this.reportingService.onIndividualPdfDownloadClick();
        this.isPdfDownloadingInProgress = true;
      }
    
      downloadSummaryPdf() {
        this.reportingService.onSummaryPdfDownloadClick();
        this.isPdfDownloadingInProgress = true;
      }

    private getEmployeeIdOnRouterChanged(route: ActivatedRoute): Observable<ActivatedRouteSnapshot> {
        return this.router.events.pipe(
            filter(x => x['state'] && x['state'].root && x['state'].root.children),
            map(x => {
                const childrenRoute: ActivatedRouteSnapshot = [...x['state'].root.children].shift();
                return (childrenRoute && childrenRoute.firstChild) ? childrenRoute.firstChild : undefined;
            })
        );
    }
}
